import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Buildings, CaretDown, Gear } from "@phosphor-icons/react";

export function BusinessSwitcher({ businesses, activeBusiness, switchBusiness, open, onToggle, onClose, innerRef }) {
  if (businesses.length === 0) return null;

  return (
    <div className="relative" ref={innerRef}>
      <button
        onClick={onToggle}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-[var(--bg-raised)] border border-[var(--border)] hover:border-[var(--border-strong)] transition-colors text-sm max-w-[120px] sm:max-w-[180px]"
        data-testid="business-switcher"
      >
        <Buildings size={14} className="text-[#FF4400] shrink-0" />
        <span className="truncate text-[var(--text-secondary)] text-xs font-medium">
          {activeBusiness?.name || "Select Business"}
        </span>
        <CaretDown size={12} className="text-[var(--text-muted)] shrink-0" />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            className="absolute top-full left-0 mt-1 w-56 bg-[var(--bg-card)] border border-[var(--border-strong)] rounded-lg shadow-lg py-1 z-50"
            data-testid="business-switcher-dropdown"
          >
            {businesses.map((b) => (
              <button
                key={b.business_id}
                onClick={async () => {
                  await switchBusiness(b.business_id);
                  onClose();
                }}
                className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 transition-colors ${
                  activeBusiness?.business_id === b.business_id
                    ? "text-[#FF4400] bg-[var(--accent-subtle)]"
                    : "text-[var(--text-secondary)] hover:bg-[var(--bg-hover)]"
                }`}
                data-testid={`switch-business-${b.business_id}`}
              >
                <Buildings size={14} weight={activeBusiness?.business_id === b.business_id ? "fill" : "regular"} />
                <span className="truncate">{b.name}</span>
              </button>
            ))}
            <div className="border-t border-[var(--border)] mt-1 pt-1">
              <Link
                to="/settings?tab=workspace"
                onClick={onClose}
                className="w-full text-left px-3 py-2 text-xs text-[var(--text-muted)] hover:text-[var(--text-secondary)] hover:bg-[var(--bg-hover)] flex items-center gap-2 transition-colors"
                data-testid="manage-businesses-link"
              >
                <Gear size={12} />
                Manage businesses
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
